import React from 'react';
import SEOHead from '@/components/marketing/SEOHead';
import PageHeader from '@/components/marketing/PageHeader';
import CTASection from '@/components/marketing/CTASection';
import VerticalCard from '@/components/marketing/VerticalCard';
import { VERTICALS } from '@/data/site-content';
import { breadcrumbJsonLd } from '@/lib/jsonld';

export default function VerticalsIndex() {
  const jsonLd = breadcrumbJsonLd([
    { label: 'Home', path: '/' },
    { label: 'Verticals' },
  ]);
  return (
    <>
      <SEOHead path="/verticals" jsonLd={jsonLd} />
      <PageHeader breadcrumbs={[{ label: 'Verticals' }]} eyebrow="Verticals" title="Vertical-aware traffic for serious advertisers" subtitle="Format and GEO recommendations tuned to the verticals where performance teams actually scale." />
      <section className="bg-[#07111F] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {VERTICALS.map((v) => <VerticalCard key={v.slug} vertical={v} />)}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
